<template>
  <v-card flat>
    <v-text-field color="primary" v-model="busqueda" clearable background-color="tertiary"
                  :label="esBiblioteca ? $tc('busqueda_materiales_biblioteca') : $tc('busqueda_materiales')"
                  hide-details solo flat>
      <template v-slot:append>
        <v-icon color="primary" large>mdi-magnify</v-icon>
      </template>
    </v-text-field>
  </v-card>
</template>

<script>
export default {
  name: "FiltroNombreMaterial",
  props: {
    esBiblioteca: {type: Boolean, default: false, required: false}
  },
  data() {
    return {
      busqueda: ""
    }
  },
  watch: {
    busqueda(val) {
      this.$emit('actualizado', val)
    }
  }

}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "busqueda_materiales": "Búsqueda de materiales...",
    "busqueda_materiales_biblioteca": "Elige un producto real para su evaluación..."
  }
}
</i18n>
<!--@formatter:oon-->